export { default } from './WatchTaggisView';



// WEBPACK FOOTER //
// ./src/components/views/WatchTaggisView/index.js